module.exports = __webpack_public_path__ + "static/media/create_sections_lock_section.4f5193c1.mov";